import { ref } from "vue";
import DocumentConstructorDataService from "@/services/documents/DocumentConstructor/DocumentConstructorDataService";
import EsedoDictionaryItem from "@/types/documents/esedo/EsedoDictionaryItem";
import EsedoPartner from "@/types/documents/esedo/EsedoPartner";

export function useEsedoDictionaries() {
  const documentTypes = ref<EsedoDictionaryItem[]>([]);
  const questionNatures = ref<EsedoDictionaryItem[]>([]);
  const partners = ref<EsedoPartner[]>([]);
  const loading = ref(false);

  async function loadAll() {
    loading.value = true;
    try {
      const [typesRes, naturesRes, partnersRes] = await Promise.all([
        DocumentConstructorDataService.getEsedoDocumentTypes(0),
        DocumentConstructorDataService.getEsedoQuestionNatures(0),
        DocumentConstructorDataService.getEsedoPartners(0),
      ]);
      documentTypes.value = typesRes.data.data.items ?? [];
      questionNatures.value = naturesRes.data.data.items ?? [];
      partners.value = partnersRes.data.data.items ?? [];
    } finally {
      loading.value = false;
    }
  }

  function resolveDocumentTypeName(id?: string | null) {
    if (id == null) return "—";
    return documentTypes.value.find((item) => item.id === id)?.name ?? String(id);
  }

  function resolveQuestionNatureName(id?: string | null) {
    if (id == null) return "—";
    return (
      questionNatures.value.find((item) => item.id === id)?.name ?? String(id)
    );
  }

  function resolvePartnerNames(ids?: string[] | null) {
    if (!ids?.length) return "—";
    return ids
      .map((id) => partners.value.find((p) => p.id === id)?.name ?? String(id))
      .join(", ");
  }

  return {
    documentTypes,
    questionNatures,
    partners,
    loading,
    loadAll,
    resolveDocumentTypeName,
    resolveQuestionNatureName,
    resolvePartnerNames,
  };
}
